import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import tiendaSinFoto from '../../img/tiendaSinFoto.jpg'
import * as tiendasOficialesService from '../servicios/tiendasOficialesService.js'
import tiendaStyles from './TiendasOficiales.module.css'

const TiendaOficial = ({ tienda, onClick }) => {
  const [logoSrc, setLogoSrc] = useState(tiendaSinFoto)

  const cargarLogo = async () => {
    if (!tienda.idTiendaOficial || !tienda.idAdjuntoLogo) {
      return null
    }
    const { data } = await tiendasOficialesService.buscarImagenPorAdjunto(
      tienda.idTiendaOficial,
      tienda.idAdjuntoLogo
    )
    return URL.createObjectURL(data)
  }

  useEffect(() => {
    let cancelled = false
    let blobUrl

    cargarLogo()
      .then((url) => {
        if (cancelled) {
          if (url) URL.revokeObjectURL(url)
          return
        }
        if (url) {
          blobUrl = url
          setLogoSrc(url)
        }
      })
      .catch(() => {
        if (!cancelled) setLogoSrc(tiendaSinFoto)
      })

    return () => {
      cancelled = true
      if (blobUrl) URL.revokeObjectURL(blobUrl)
    }
  }, [tienda.idTiendaOficial, tienda.idAdjuntoLogo])

  return (
    <div
      className={tiendaStyles.cardTienda}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick()
        }
      }}
    >
      <div className={tiendaStyles.logoContainer}>
        <img className={tiendaStyles.logoTienda} src={logoSrc || ''} alt={tienda.nombreTienda} />
      </div>
      <p className={tiendaStyles.nombreTienda}>{tienda.nombreTienda}</p>
    </div>
  )
}

TiendaOficial.propTypes = {
  tienda: PropTypes.shape({
    idTiendaOficial: PropTypes.number,
    idAdjuntoLogo: PropTypes.number,
    nombreTienda: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func.isRequired
}

export default TiendaOficial
